import { render, staticRenderFns } from "./nopower.vue?vue&type=template&id=a0347c4c&"
import script from "./nopower.vue?vue&type=script&lang=js&"
export * from "./nopower.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports